import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetcher from 'lib/common/fetcher';
import panZoom from 'behaviours/panZoom';

class MiniMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      miniMapSvg: null
    };

    this.updateThumbScope = this.updateThumbScope.bind(this);
    this.updateMainViewPan = this.updateMainViewPan.bind(this);
  }

  componentDidMount() {
    if (this.props.currentFacility && this.props.currentFacility.miniMapSvg) {
      fetcher
        .fetchHtml(this.props.currentFacility.miniMapSvg)
        .then(miniMapSvg => {
          this.setState({
            miniMapSvg: miniMapSvg
          });
        });
    }
  }

  componentDidUpdate() {
    if (this.state.miniMapSvg) {
      const mainPanZoomInstance = this.props.mainPanZoomInstance;

      const thumbnailSVG = this._thumbnailEl.querySelector('svg');
      this.thumbnailPanZoomInstance = panZoom(thumbnailSVG, {
        zoomEnabled: false,
        panEnabled: false,
        controlIconsEnabled: false,
        dblClickZoomEnabled: false,
        preventMouseEventsDefault: true
      });

      mainPanZoomInstance.setOnPan(this.updateThumbScope);
      this.updateThumbScope();

      this._viewerEl.addEventListener('click', this.updateMainViewPan);
      this._viewerEl.addEventListener('mousemove', this.updateMainViewPan);
    }
  }

  componentWillUnmount() {
    this._viewerEl.removeEventListener('click', this.updateMainViewPan);
    this._viewerEl.removeEventListener('mousemove', this.updateMainViewPan);
  }

  updateThumbScope() {
    let mainPanZoomInstance = this.props.mainPanZoomInstance;
    let thumbnailPanZoomInstance = this.thumbnailPanZoomInstance;

    let scope = this._viewerScopeEl;
    let mainPanX = mainPanZoomInstance.getPan().x;
    let mainPanY = mainPanZoomInstance.getPan().y;
    let mainWidth = mainPanZoomInstance.getSizes().width;
    let mainHeight = mainPanZoomInstance.getSizes().height;
    let mainZoom = mainPanZoomInstance.getSizes().realZoom;
    let thumbPanX = thumbnailPanZoomInstance.getPan().x;
    let thumbPanY = thumbnailPanZoomInstance.getPan().y;
    let thumbZoom = thumbnailPanZoomInstance.getSizes().realZoom;

    let thumbByMainZoomRatio = thumbZoom / mainZoom;

    let scopeX = thumbPanX - mainPanX * thumbByMainZoomRatio;
    let scopeY = thumbPanY - mainPanY * thumbByMainZoomRatio;
    let scopeWidth = mainWidth * thumbByMainZoomRatio;
    let scopeHeight = mainHeight * thumbByMainZoomRatio;

    if (scope) {
      scope.setAttribute('x', scopeX + 1);
      scope.setAttribute('y', scopeY + 1);
      scope.setAttribute('width', scopeWidth - 2);
      scope.setAttribute('height', scopeHeight - 2);
    }
  }

  updateMainViewPan(evt) {
    if (evt.which == 0 && evt.button == 0) {
      return false;
    }

    let mainPanZoomInstance = this.props.mainPanZoomInstance;
    let thumbnailPanZoomInstance = this.thumbnailPanZoomInstance;

    let dim = this._viewerEl.getBoundingClientRect();

    let mainSizes = mainPanZoomInstance.getSizes();
    let thumbSizes = thumbnailPanZoomInstance.getSizes();

    let mainZoom = mainSizes.realZoom;
    let thumbWidth = thumbSizes.width;
    let thumbZoom = thumbSizes.realZoom;

    let thumbPanX = evt.clientX - dim.left;
    let thumbPanY = evt.clientY - dim.top;

    let mainPanX = (-thumbPanX * mainZoom) / thumbZoom;
    let mainPanY = (-thumbPanY * mainZoom) / thumbZoom;
    let panXOffset = thumbWidth * 2 * mainZoom;

    mainPanZoomInstance.pan({
      x: mainPanX + panXOffset,
      y: mainPanY
    });
  }

  render() {
    /* eslint-disable react/no-danger */
    /* eslint-disable react/no-danger-with-children */
    return this.state.miniMapSvg ? (
      <div className="syos-minimap">
        <svg className="syos-minimap__viewer" ref={el => (this._viewerEl = el)}>
          <g>
            <rect
              ref={el => (this._viewerScopeEl = el)}
              fill="red"
              fillOpacity="0.1"
              stroke="red"
              strokeWidth="2px"
              x="0"
              y="0"
              width="0"
              height="0"
            />

            <line
              id="line1"
              stroke="red"
              strokeWidth="2px"
              x1="0"
              y1="0"
              x2="0"
              y2="0"
            />

            <line
              id="line2"
              stroke="red"
              strokeWidth="2px"
              x1="0"
              y1="0"
              x2="0"
              y2="0"
            />
          </g>
        </svg>
        <div
          className="syos-minimap__thumbnail"
          ref={el => (this._thumbnailEl = el)}
          dangerouslySetInnerHTML={{
            __html: this.state.miniMapSvg
          }}
        />
      </div>
    ) : null;
  }
}

MiniMap.propTypes = {
  currentFacility: PropTypes.object,
  mainPanZoomInstance: PropTypes.object
};

export default MiniMap;



// WEBPACK FOOTER //
// ./src/javascripts/components/MiniMap.js